import {
    Button,
    FormInstance,
    notification,
    Select,
    Space,
    Typography
} from 'antd';
import * as React from 'react';
import AuditorApiService from '../../api/AuditorApiService';
import { Content } from 'antd/lib/layout/layout';
import { RouteComponentProps } from 'react-router';
import FormItem from 'antd/lib/form/FormItem';
import FormValidationUtil from '../../utils/FormValidationUtil';
import CurrentUser from '../../utils/CurrentUser';
import CustomForm from '../shared/CustomForm';
import AuditorDTO from '../../models/AuditorDTO';
import EditCommitteeAuditorFormDTO from '../../models/EditCommitteeAuditorFormDTO';

const Option = Select.Option;

interface EditAuditorProps {
}

interface EditAuditorState {
    committeeAuditorInfo: EditCommitteeAuditorFormDTO;
    btnDisable: boolean;
    auditors: AuditorDTO[];
    loading: boolean;
}

class EditAuditor extends React.Component<RouteComponentProps<EditAuditorProps>, EditAuditorState> {
    private readonly _formRef = React.createRef<FormInstance>();

    constructor(props: RouteComponentProps<EditAuditorProps>) {
        super(props);
        this.state = {
            committeeAuditorInfo: EditCommitteeAuditorFormDTO.create(),
            btnDisable: false,
            auditors: [],
            loading: false
        };
    }

    componentDidMount() {
        this.getAuditors();
        this.getCurrentAuditor(CurrentUser.Get()?.committeeId || '');
    }

    render() {
        const { committeeAuditorInfo, btnDisable, auditors, loading } = this.state;
        const { ...formProps } = this.props;

        return (
            <>
                { !loading &&
                    <Content className="content-pad">
                        <Typography.Title level={4}>Edit Auditor</Typography.Title>
                        <CustomForm {...formProps}
                            formRef={this._formRef}
                            initialValues={committeeAuditorInfo}
                            layout="vertical"
                            onFinish={this.handleSave} >
                            <FormItem
                                name="auditorId"
                                label="Auditor"
                                rules={[FormValidationUtil.RequiredNumber('Auditor is required')]}
                                >
                                <Select style={{ width: 250 }}>
                                    <Option value="" disabled={true}>-- Select Auditor --</Option>
                                    {auditors.map(a => (
                                        <Option key={a.auditorId} value={a.auditorId}>{`${a.lastName}, ${a.firstName}`}</Option>
                                    ))}
                                </Select>
                            </FormItem>
                            <Space>
                                <Button type="primary" disabled={btnDisable} htmlType="submit">Save</Button>
                            </Space>
                        </CustomForm >
                    </Content>
                }
            </>
        );
    }

    private getAuditors = () => {
        this.setState({ loading: true });
        AuditorApiService.getAuditors()
            .then(auditorList => {
                if (auditorList) {
                    this.setState({ auditors: auditorList, loading: false });
                }
                else {
                    notification.error({
                        message: 'Error while fetching auditors',
                        description: 'Not found'
                    });
                }
            }).catch(() => {
                this.setState({ loading: false });
                notification.error({
                    message: 'Error while fetching auditors',
                    description: ''
                });
            });
    }

    private getCurrentAuditor = (committeeId: string) => {
        this.setState({ loading: true });
        AuditorApiService.getAuditorByCommitteeId(committeeId)
            .then(auditor => {
                this.setState({ loading: false });
                this._formRef.current?.setFieldsValue(auditor);
            }).catch(() => {
                this.setState({ loading: false });
                notification.error({
                    message: 'Error while fetching current auditor',
                    description: ''
                });
            });
    }

    private handleSave = (auditor: EditCommitteeAuditorFormDTO) => {
        this.setState({ btnDisable: true });

        AuditorApiService.editCommitteeAuditor(
            CurrentUser.Get()?.committeeId || '',
            auditor.auditorId
        )
            .then(() => {
                notification.success({
                    message: 'Auditor saved successfully',
                    description: ''
                });
                this.setState({ btnDisable: false });
            })
            .catch((error) => {
                notification.error({
                    message: error.message,
                    description: error.description
                });
            });
    }
}

export default EditAuditor;